var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuCoursesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6647 0H4.06472C2.61752 0 0.464722 0.9588 0.464722 3.6V20.4C0.464722 23.0412 2.61752 24 4.06472 24H22.0647V21.6H4.07912C3.52472 21.5856 2.86472 21.3672 2.86472 20.4C2.86472 20.2788 2.87552 20.1708 2.89352 20.0724C3.02792 19.3812 3.59432 19.212 4.07912 19.2H22.0647V2.4C22.0647 1.76348 21.8119 1.15303 21.3618 0.702944C20.9117 0.252856 20.3012 0 19.6647 0ZM19.6647 10.8L17.2647 9.6L14.8647 10.8V2.4H19.6647V10.8Z",
    fill: "#57769C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCoursesIcon);
export default __webpack_public_path__ + "static/media/menu-courses-icon.753b05134ba8ff40746720a6e19ffaa4.svg";
export { ForwardRef as ReactComponent };